import { Badge, Button, IconButton, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import DeleteIcon from "@material-ui/icons/Delete"
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket"
import StarIcon from "@material-ui/icons/Star"
import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"

const PONTOS_INICIAL = 1356

const PRODUTOS = [
    {
        id: 1,
        nome: "Coca-Cola Lata",
        pontos: 700,
        imagem: "https://clientefiel-arquivos.s3.us-east-1.amazonaws.com/mateusfelipe_hud/9122/fotos_produtos/img_produto_20260401140622.webp",
    },
    {
        id: 2,
        nome: "Pepsi Lata",
        pontos: 700,
        imagem: "https://clientefiel-arquivos.s3.us-east-1.amazonaws.com/mateusfelipe_hud/9122/fotos_produtos/img_produto_20260401140628.png",
    },
    {
        id: 3,
        nome: "Guaraná Lata",
        pontos: 700,
        imagem: "https://clientefiel-arquivos.s3.us-east-1.amazonaws.com/mateusfelipe_hud/9122/fotos_produtos/img_produto_20260401140635.webp",
    },
    {
        id: 4,
        nome: "Sobremesa Brownie",
        pontos: 1500,
        imagem: "https://clientefiel-arquivos.s3.us-east-1.amazonaws.com/mateusfelipe_hud/9122/fotos_produtos/img_produto_20260401140927.png",
    },
    {
        id: 5,
        nome: "X-tudo",
        pontos: 2500,
        imagem: "https://clientefiel-arquivos.s3.us-east-1.amazonaws.com/mateusfelipe_hud/9122/fotos_produtos/img_produto_20250923185822.jpg",
    },
]

const useStyles = makeStyles({
    root: {
        paddingBottom: "5rem",
        padding: "0.4rem",
        maxWidth: "700px",
        margin: "auto",
    },
    pontosHeader: {
        padding: "1.25rem 1.25rem 1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    pontosLabel: {
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#888",
    },
    pontosRow: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        marginTop: "2px",
    },
    starIconGrande: {
        color: "#f5a623",
        fontSize: "1.6rem",
    },
    pontosOriginal: {
        color: "#aaa",
    },
    sacolaToggle: {
        background: "rgba(0,0,0,0.05)",
        borderRadius: "12px",
        padding: "8px",
    },
    conteudo: {
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 1rem",
    },
    sacolaContainer: {
        background: "#fff",
        borderRadius: "16px",
        padding: "1rem",
        marginBottom: "1rem",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
    },
    sacolaTitulo: {
        fontWeight: 700,
        marginBottom: "0.75rem",
        color: "#1a1a2e",
    },
    sacolaItemVazio: {
        textAlign: "center",
        padding: "0.5rem 0",
    },
    sacolaItem: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "0.6rem 0",
        borderBottom: "1px solid #f0f0f0",
    },
    sacolaItemResgatado: {
        opacity: 0.5,
    },
    sacolaItemImg: {
        width: 40,
        height: 40,
        borderRadius: "8px",
        objectFit: "cover",
        flexShrink: 0,
    },
    sacolaItemInfo: {
        flex: 1,
        minWidth: 0,
    },
    sacolaItemNome: {
        fontWeight: 600,
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    sacolaItemNomeRiscado: {
        textDecoration: "line-through",
    },
    sacolaItemPontosRow: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
    },
    starIconPequeno: {
        fontSize: "0.7rem",
        color: "#f5a623",
    },
    sacolaItemPontos: {
        color: "#f5a623",
        fontWeight: 700,
    },
    resgatadoMsg: {
        color: "#43a047",
        fontSize: "0.6rem",
        fontWeight: 600,
    },
    semPontosMsg: {
        color: "#e53935",
        fontSize: "0.6rem",
    },
    btnResgatar: {
        borderRadius: "20px",
        textTransform: "none",
        fontSize: "0.65rem",
        fontWeight: 600,
        padding: "4px 12px",
        whiteSpace: "nowrap",
        flexShrink: 0,
    },
    btnRemover: {
        color: "#e57373",
        flexShrink: 0,
    },
    sectionLabel: {
        color: "#888",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        fontWeight: 600,
    },
    produtoRow: {
        marginTop: "0.5rem",
    },
    produtoCol: {
        marginBottom: "0.6rem",
        padding: "0 6px",
    },
    produtoCard: {
        background: "#fff",
        borderRadius: "14px",
        boxShadow: "0 1px 8px rgba(0,0,0,0.07)",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        transition: "box-shadow 0.2s",
    },
    produtoImg: {
        width: 68,
        height: 68,
        objectFit: "cover",
        flexShrink: 0,
        borderRadius: "14px 0 0 14px",
    },
    produtoInfo: {
        flex: 1,
        padding: "0 10px",
        minWidth: 0,
    },
    produtoNome: {
        fontWeight: 700,
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#1a1a2e",
    },
    produtoPontosRow: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
        marginTop: "3px",
    },
    starIconMedio: {
        fontSize: "0.75rem",
        color: "#f5a623",
    },
    produtoPontos: {
        fontWeight: 700,
        color: "#f5a623",
    },
    faltamPontos: {
        color: "#e53935",
        fontSize: "0.6rem",
        display: "block",
    },
    produtoBtnContainer: {
        padding: "0 10px 0 0",
        flexShrink: 0,
    },
    btnAdicionar: {
        borderRadius: "20px",
        textTransform: "none",
        fontSize: "0.65rem",
        fontWeight: 600,
        padding: "4px 12px",
        whiteSpace: "nowrap",
        minWidth: 0,
    },
})

export function PontosFidelidade() {
    const classes = useStyles()
    const [sacola, setSacola]: any = useState([])
    const [pontosRestantes, setPontosRestantes]: any = useState(PONTOS_INICIAL)
    const [verSacola, setVerSacola] = useState(false)

    const adicionarNaSacola = (produto: any) => {
        setSacola((prev: any) => [...prev, { ...produto, resgatado: false }])
        setVerSacola(true)
    }

    const removerDaSacola = (index: any) =>
        setSacola((prev: any) => prev.filter((_: any, i: any) => i !== index))

    const jaAdicionado = (id: any) => sacola.some((item: any) => item.id === id)

    const resgatarItem = (index: any) => {
        setPontosRestantes((prev: any) => prev - sacola[index].pontos)
        setSacola((prev: any) =>
            prev.map((item: any, i: any) => (i === index ? { ...item, resgatado: true } : item))
        )
    }

    return (
        <div style={{ height: "100%" }}>
            <div className={classes.root}>
                <div className={classes.pontosHeader}>
                    <div>
                        <Typography variant="caption" className={classes.pontosLabel}>
                            Seus pontos
                        </Typography>
                        <div className={classes.pontosRow}>
                            <StarIcon className={classes.starIconGrande} />
                            <Typography variant="h4" style={{ fontWeight: 700, lineHeight: 1 }}>
                                {pontosRestantes}
                            </Typography>
                            <Typography
                                variant="body2"
                                className={classes.pontosOriginal}
                                style={{ alignSelf: "flex-end", marginBottom: "2px" }}
                            >
                                pts
                            </Typography>
                        </div>
                        {pontosRestantes < PONTOS_INICIAL && (
                            <Typography variant="caption" className={classes.pontosOriginal}>
                                de {PONTOS_INICIAL} pts originais
                            </Typography>
                        )}
                    </div>

                    <IconButton
                        onClick={() => setVerSacola(v => !v)}
                        className={classes.sacolaToggle}
                    >
                        <Badge badgeContent={sacola.length} color="error">
                            <ShoppingBasketIcon />
                        </Badge>
                    </IconButton>
                </div>

                <div className={classes.conteudo}>
                    {verSacola && (
                        <div className={classes.sacolaContainer}>
                            <Typography variant="subtitle2" className={classes.sacolaTitulo}>
                                🛒 Sacola de resgate
                            </Typography>

                            {sacola.length === 0 ? (
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    className={classes.sacolaItemVazio}
                                >
                                    Adicione itens abaixo para resgatar.
                                </Typography>
                            ) : (
                                sacola.map((item: any, index: any) => {
                                    const podeResgatar =
                                        !item.resgatado && item.pontos <= pontosRestantes
                                    return (
                                        <div
                                            key={index}
                                            className={`${classes.sacolaItem} ${
                                                item.resgatado ? classes.sacolaItemResgatado : ""
                                            }`}
                                        >
                                            <img
                                                src={item.imagem}
                                                alt={item.nome}
                                                className={classes.sacolaItemImg}
                                            />
                                            <div className={classes.sacolaItemInfo}>
                                                <Typography
                                                    variant="caption"
                                                    className={`${classes.sacolaItemNome} ${
                                                        item.resgatado
                                                            ? classes.sacolaItemNomeRiscado
                                                            : ""
                                                    }`}
                                                >
                                                    {item.nome}
                                                </Typography>
                                                <div className={classes.sacolaItemPontosRow}>
                                                    <StarIcon className={classes.starIconPequeno} />
                                                    <Typography
                                                        variant="caption"
                                                        className={classes.sacolaItemPontos}
                                                    >
                                                        {item.pontos} pts
                                                    </Typography>
                                                </div>
                                                {item.resgatado && (
                                                    <Typography
                                                        variant="caption"
                                                        className={classes.resgatadoMsg}
                                                    >
                                                        ✓ Resgatado
                                                    </Typography>
                                                )}
                                                {!item.resgatado &&
                                                    item.pontos > pontosRestantes && (
                                                        <Typography
                                                            variant="caption"
                                                            className={classes.semPontosMsg}
                                                        >
                                                            Pontos insuficientes
                                                        </Typography>
                                                    )}
                                            </div>
                                            {!item.resgatado && (
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!podeResgatar}
                                                    onClick={() => resgatarItem(index)}
                                                    className={classes.btnResgatar}
                                                >
                                                    Resgatar
                                                </Button>
                                            )}
                                            {!item.resgatado && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => removerDaSacola(index)}
                                                    className={classes.btnRemover}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </div>
                                    )
                                })
                            )}
                        </div>
                    )}

                    <Typography variant="caption" className={classes.sectionLabel}>
                        Disponíveis para resgate
                    </Typography>

                    <Row className={classes.produtoRow}>
                        {PRODUTOS.map(produto => {
                            const adicionado = jaAdicionado(produto.id)
                            const semPontos = produto.pontos > pontosRestantes

                            return (
                                <Col xs={12} key={produto.id} className={classes.produtoCol}>
                                    <div className={classes.produtoCard}>
                                        <img
                                            src={produto.imagem}
                                            alt={produto.nome}
                                            className={classes.produtoImg}
                                        />
                                        <div className={classes.produtoInfo}>
                                            <Typography
                                                variant="caption"
                                                className={classes.produtoNome}
                                            >
                                                {produto.nome}
                                            </Typography>
                                            <div className={classes.produtoPontosRow}>
                                                <StarIcon className={classes.starIconMedio} />
                                                <Typography
                                                    variant="caption"
                                                    className={classes.produtoPontos}
                                                >
                                                    {produto.pontos} pts
                                                </Typography>
                                            </div>
                                            {semPontos && !adicionado && (
                                                <Typography
                                                    variant="caption"
                                                    className={classes.faltamPontos}
                                                >
                                                    Faltam {produto.pontos - pontosRestantes} pts
                                                </Typography>
                                            )}
                                        </div>
                                        <div className={classes.produtoBtnContainer}>
                                            <Button
                                                size="small"
                                                variant={adicionado ? "outlined" : "contained"}
                                                color="primary"
                                                disabled={adicionado}
                                                onClick={() => adicionarNaSacola(produto)}
                                                className={classes.btnAdicionar}
                                            >
                                                {adicionado ? "✓ Na sacola" : "Adicionar"}
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            </div>
        </div>
    )
}
